import { Component, Injector, ViewChild } from '@angular/core';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { NgForm } from '@angular/forms';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { useCache } from "@bndes/bndes-ux4/bndes-angular-utils";
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TarefasLimitesService extends FgiBackEndService<any> {

  @ViewChild('formTarefasLimites', {static: false}) form: NgForm;

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/tarefas/limite';
  }

  buscarLimiteBeneficiarioFg2(cpfOuCnpjBeneficiario: string, cnpjAgente: string, idTranche:number): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    const url = `${this.BASE_URL}/beneficiario/${cpfOuCnpjBeneficiario}/agente-financeiro/${cnpjAgente}/tranche/${idTranche}`;
    return this.http.get(url, { headers}).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  buscarLimiteBeneficiarioFgiTradicional(cpfOuCnpjBeneficiario: string, cnpjAgente: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    const url = `${this.BASE_URL}/beneficiario/${cpfOuCnpjBeneficiario}/agente-financeiro/${cnpjAgente}/fgi`;
    return this.http.get(url, { headers}).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  calcularLimiteExposicao(ideOperacaoGarantida: number) {
    const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
    const url = `${this.BASE_URL}/exposicao/${ideOperacaoGarantida}`;
    return this.http.get(url, { headers}).pipe
     (catchError((e) => this.handleError(e))) as Observable<any>;
  }
}